moduleViewApp.service("PartnerTagUploadService", ['$rootScope', '$q', 'DebugHelper', 'myPartnersService', 'TagTypeResource', ($rootScope, $q, DebugHelper, myPartnersService, TagTypeResource) ->
  $scope = $rootScope.$new()

  DebugHelper.register("PartnerTagUploadService", $scope)

  _.assignIn $scope,

    normalizeRepeatableHeading: (heading) ->
      for pair in _.toPairs($scope.repeatableHeadingCompatibilityMap)
        pattern = pair[0]
        normalizedPattern = pair[1]
        re = new RegExp("\^" + pattern + "\$")
        match = heading.match(re)
        if match
          return ["tag", normalizedPattern, match[1] - 1]
        else
          continue
      false
      
    initialize: ->
      TagTypeResource.get partner_id: myPartnersService.currentProductPartner.id
      , (success) ->
        $scope.tags = success.data
        $scope.repeatableHeadingCompatibilityMap = {}

        for tag_type in $scope.tags
          key = "association_(\\\d)_tag_" + tag_type.attributes.slug
          value = tag_type.attributes.slug
          $scope.repeatableHeadingCompatibilityMap[key] = value

  $scope
])
